import { z } from 'zod';
import type { AppState, StaffAccessStatus } from './types';

export const noStaffAccess: StaffAccessStatus = {
  role: null,
  allowed: false,
  mfa_required: false,
  owner_mfa_deferred: false,
};
const schema = z
  .object({
    role: z.enum(['owner', 'administrator', 'moderator', 'editor']).nullable(),
    allowed: z.boolean(),
    mfa_required: z.boolean(),
    owner_mfa_deferred: z.boolean(),
  })
  .strict();

/** Invalid or unavailable server decisions never turn an assigned role into access. */
export function readStaffAccessStatus(input: unknown): StaffAccessStatus {
  const result = schema.safeParse(input);
  if (!result.success) return { ...noStaffAccess };
  const status = result.data;
  if (
    (status.allowed && (!status.role || status.mfa_required)) ||
    (status.owner_mfa_deferred && status.role !== 'owner')
  )
    return { ...noStaffAccess };
  return status;
}

export function effectiveStaffRole(status: StaffAccessStatus): AppState['demo_role'] {
  return status.allowed && status.role ? status.role : 'member';
}
